<app-avatar
  class="u-display-block"
  [showCamera]="showCamera"
  [size]="size"
  [name]="item?.first_name || item?.full_name || ''"
  [imageUrl]="item?.portrait_original_url"
>
</app-avatar>
